import React from 'react';
import { LoginContainer } from '../../components/auth/loginContainer';

const LoginPage = () => (
  <LoginContainer />
)

export default LoginPage
